import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ExpertiseSectionProps {
  expertise: string;
}

export function ExpertiseSection({ expertise }: ExpertiseSectionProps) {
  const { t } = useTranslation(["talent"]);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-semibold flex items-center gap-2">
          <Badge
            variant="secondary"
            className="h-8 w-8 rounded-lg flex items-center justify-center p-0"
          >
            <Briefcase className="h-4 w-4 text-primary" />
          </Badge>
          {t("talent:experience.fields.areas_of_expertise")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">
          {expertise}
        </p>
      </CardContent>
    </Card>
  );
}
